export const sectionBase = "components_db";
export const routeIdBase = `${sectionBase}`;

export const sectionPath = "/components-db/";
export const dataPath = `${sectionPath}data/`;
export const componentsPath = `${sectionPath}components/`;
export const presetsPath = `${sectionPath}presets/`;

